var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmartIcon = function SvgSmartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 36"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#SmartIcon_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.081 25.82c-.32 0-.645-.08-.942-.25l-8.564-4.892a10.97 10.97 0 0 1-5.188-6.69A10.88 10.88 0 0 1 1.489 5.62C4.549.35 11.36-1.468 16.675 1.567l8.564 4.891a1.867 1.867 0 0 1 .695 2.561 1.9 1.9 0 0 1-2.583.69l-8.563-4.892C11.28 2.815 6.784 4.014 4.765 7.491s-.81 7.935 2.697 9.937l8.564 4.892a1.866 1.866 0 0 1 .694 2.56c-.35.603-.986.94-1.64.94"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E51D73",
    d: "M16.857 36c-1.923 0-3.82-.499-5.532-1.476l-8.564-4.891a1.866 1.866 0 0 1-.694-2.56 1.9 1.9 0 0 1 2.582-.69l8.564 4.891a7.34 7.34 0 0 0 5.569.721 7.28 7.28 0 0 0 4.452-3.395 7.18 7.18 0 0 0 .727-5.522 7.24 7.24 0 0 0-3.423-4.416l-8.564-4.89a1.867 1.867 0 0 1-.696-2.561 1.9 1.9 0 0 1 2.583-.69l8.564 4.892a10.97 10.97 0 0 1 5.188 6.69c.772 2.844.38 5.817-1.102 8.369a11.03 11.03 0 0 1-6.746 5.145c-.962.256-1.938.383-2.908.383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "SmartIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v36H0z"
  })))));
};
export default SvgSmartIcon;